import { SetRewardsConfigurationAction } from "../actions/CacheSetRewardsConfiguration/CacheSetRewardsConfigurationActionTypes";
import { CacheReducerState } from "../models/definitions";
import { initialState } from "./CacheInitialState";

export const handleSetRewardsConfiguration = (
  state = initialState,
  { payload }: SetRewardsConfigurationAction
): CacheReducerState => ({
  ...state,
  rewardsConfiguration: payload.rewardsConfiguration
});
